(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["home-logos"] && !Shopify.designMode) return;
  try {
    
const logoSlider = new Splide(".splide.logo-slider", {
	type: "slide",
	rewind: true,
	speed: 300,
	gap: "2rem",
	height: "20rem",
	perPage: 4,
	perMove: 4,
	focus: 0,
	classes: {
		arrows: 'splide__arrows logo-slider__arrows',
		arrow: 'splide__arrow logo-slider__arrow',
		prev: 'splide__arrow--prev logo-slider__arrow--prev',
		next: 'splide__arrow--next logo-slider__arrow--next',
	},
	arrowPath: "M30.3,18.9c0.6,0.6,0.6,1.6,0,2.2L11.9,39.6c-0.6,0.6-1.6,0.6-2.2,0c-0.6-0.6-0.6-1.6,0-2.2L27.1,20L9.7,2.6 C9.1,2,9.1,1,9.7,0.4c0.6-0.6,1.6-0.6,2.2,0C11.9,0.4,30.3,18.9,30.3,18.9z",
	autoplay: true,
	breakpoints: {
		939: {
			perPage: 3,
			perMove: 3
		},
		749: {
			destroy: true
		}
	}
});
logoSlider.mount();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-slider"] && !Shopify.designMode) return;
  try {
    
const homeSlider = new Splide(".splide.home-slider", {
	type: "loop",
	speed: 300,
	width: "100vw",
	autoWidth: true,
	autoHeight: true,
	focus: "center",
	classes: {
		arrows: 'splide__arrows home-slider__arrows',
		arrow: 'splide__arrow home-slider__arrow',
		prev: 'splide__arrow--prev home-slider__arrow--prev',
		next: 'splide__arrow--next home-slider__arrow--next',
	},
	arrowPath: "M30.3,18.9c0.6,0.6,0.6,1.6,0,2.2L11.9,39.6c-0.6,0.6-1.6,0.6-2.2,0c-0.6-0.6-0.6-1.6,0-2.2L27.1,20L9.7,2.6 C9.1,2,9.1,1,9.7,0.4c0.6-0.6,1.6-0.6,2.2,0C11.9,0.4,30.3,18.9,30.3,18.9z",
	autoplay: true
});
homeSlider.mount();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
